import { HttpHeaders } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { CommonService } from 'src/app/service/common.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit {

  constructor(public cm:CommonService) { }

  isLoginBtn = false;
  isAdmin = false;
  ngOnInit() {
    if(this.cm.checkPermission(['member'])){
      this.isLoginBtn = true;
    } else {
      this.cm.goto('/login');
    }
    if(this.cm.checkPermission(['admin'])){
      this.isAdmin = true;
    }
  }

  logout(){
    var url = this.cm.getUrl() + '/v1.0/oauth/revoke';
    const options = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json'
      })
    };
    const body = {
      'token':this.cm.getConfig().access_token
    }
    this.cm.http.post(url,body,options).toPromise().then((data)=>{
      sessionStorage.clear();
      this.cm.toastr.success('ออกจากระบบ','สำเร็จ');
      this.cm.goto('login');
    }).catch((error)=>{
      this.cm.toastr.warning(error.message,'ไม่สำเร็จ');
    })
  }

}
